export default __webpack_public_path__ + "static/media/snowuns-mobile-text.7ab4a5e2.webp";